import React, { useState, useEffect } from 'react'

const GlobalContext = React.createContext()

const GlobalProvider = ({ children, globalEdit, stateEdit }) => {
  const [editGlobal, setEditGlobal] = useState(false)

  useEffect(() => {
    setEditGlobal(globalEdit)
  }, [globalEdit])

  useEffect(() => {
    setEditGlobal(stateEdit)
  }, [stateEdit])

  const handleEditingClient = (event) => {
    if (event.target.value === 'Actualizar cliente') {
      setEditGlobal(true)
    } else if (event.target.value === 'Cancelar') {
      const confirmation = window.confirm(
        '¿Está seguro que quiere continuar? Los cambios editados no serán guardados'
      )
      if (confirmation) {
        setEditGlobal(false)
      }
    }
  }

  return (
    <GlobalContext.Provider
      value={{
        globalEdit: editGlobal,
        handleEditingClient: handleEditingClient
      }}
    >
      {children}
    </GlobalContext.Provider>
  )
}

const GlobalConsumer = GlobalContext.Consumer

export { GlobalProvider, GlobalConsumer, GlobalContext }
